import Grafana from "../../../../docs/_images/grafana.png";
import * as React from 'react';
export default {
  Grafana,
  React
};